/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1763ac72cd0660f7afac913f1afb10ff>>
 * @codegenCommand yarn build:icon-glyphs
 */
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _UNSAFE_baseNew = _interopRequireDefault(require("@atlaskit/icon/UNSAFE_base-new"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "EyeOpenStrikethrough".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Intended uses: unwatch page in Confluence, hide password in text field, and unfollow in Atlas.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */
const EyeOpenStrikethroughIcon = props => /*#__PURE__*/_react.default.createElement(_UNSAFE_baseNew.default, Object.assign({
  dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="m1 1 2.919 2.919M15 15l-2.92-2.92M3.92 3.92C2.524 4.792 1.436 6.096.871 7.638a1.06 1.06 0 0 0 0 .724C1.914 11.212 4.745 13.25 8 13.25c1.493 0 2.898-.43 4.08-1.17M3.92 3.92l2.49 2.49m5.672 5.672L9.59 9.59m0 0a2.25 2.25 0 0 1-3.182-3.182M9.59 9.59 6.409 6.409m.005-3.495A7.7 7.7 0 0 1 8 2.75c3.255 0 6.086 2.039 7.129 4.888.085.234.085.49 0 .724a7.2 7.2 0 0 1-1.187 2.08"/>`
  // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
}, props));
EyeOpenStrikethroughIcon.displayName = 'EyeOpenStrikethroughIcon';
var _default = exports.default = EyeOpenStrikethroughIcon;